<template>
  <v-row style="overflow: auto">
    <v-col md="6" lg="5" class="pt-0">
      <v-simple-table class="table-full table-fixed-height pt-3" :fixed-header="true" style="border-right: 1px solid #e0e0e0;border-bottom: 1px solid #e0e0e0;border-radius: 0;">
        <thead>
          <tr>
            <th class="text-start pl-8">SOURCES</th>
            <th>Utilisateur</th>
            <th>ACTION</th>
          </tr>
        </thead>

        <tbody>
          <tr v-if="list.length > 0" v-for="(item, index) in list" :key="index">
            <td class="text-start pl-8">{{ item.name }}</td>
            <td>{{ item.number }}</td>
            <td>
              <v-btn class="ma-2 ml-0 text-none body-1" small depressed rounded color="primary" @click="pushNotification(item.siteId)">Push</v-btn>
            </td>
          </tr>

          <tr class="unregister-table-bottom text-left">
              <td class="text-start pl-8 red--text"><strong>TOTAL</strong></td>
              <td class="red--text"><strong>{{totalItem()}}</strong></td>
              <td>
                <v-btn class="ma-2 ml-0 text-none body-1" small depressed rounded color="primary" @click="pushAllNotification()">Push</v-btn>
              </td>
          </tr>
        </tbody>

      </v-simple-table>
    </v-col>
    <PushNotificationForm v-model="dialogPushNotificationForm" :pushBrowser="true" :site-id="siteId" />
  </v-row>
</template>

<script>
  import Loading from '../../components/Loading.vue';
  import BroadcastService from '../../services/broadcast.service';
  import PushNotificationForm from '@/components/forms/PushNotificationForm';
  export default {
  name: "Unregister",
  components: {
    Loading,
    PushNotificationForm
  },
  data() {
    return {
      list: [],
      dialogPushNotificationForm: false,
      siteId: null
    };
  },
  created() {
    this.loadList()
  },
  computed: {},
  methods: {
    pushNotification(siteId){
        this.siteId = siteId;
        this.dialogPushNotificationForm = true;
    },
    pushAllNotification() {
      this.siteId = null;
      this.dialogPushNotificationForm = true;
    },
    async loadList() {
      let a = await BroadcastService.getList();
      if(a) {
        this.list = a.data;
      }
    },
    totalItem: function(){
      let sum = 0;
      for(let i = 0; i < this.list.length; i++){
        sum += parseFloat(this.list[i].number);
      }
     return sum;
   }

  }
};
</script>
